import { Link } from 'react-router-dom';

const footerGroups = [
  {
    title: '浏览',
    links: [
      { label: '首页', to: '/' },
      { label: '最新上架', to: '/category/latest' },
      { label: '热门榜单', to: '/category/hot' },
      { label: '经典修复', to: '/category/classic' },
    ],
  },
  {
    title: '站内',
    links: [
      { label: '搜索影片', to: '/search' },
      { label: '关于我们', to: '/about' },
      { label: '常见问题', to: '/faq' },
    ],
  },
];

const friends = [
  { label: 'TMDB 影视资料库', href: 'https://aaxtcr.cn' },
  { label: 'Letterboxd 影评社区', href: 'https://letterboxd.com' },
  { label: 'MUBI 策展影院', href: 'https://mubi.com' },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 md:mt-28 border-t border-accent-800/40 bg-accent-950">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center font-label text-lg">
                AV
              </span>
              <span className="text-lg font-bold tracking-tight text-foreground-950">av免费网站</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个面向成人影视爱好者的高清影片浏览门户。整理最新上架、人气榜单与经典修复三类内容，提供分类筛选、关键词搜索与收藏记录，让找片这件事更简单。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500 max-w-md">
              本站全部影片名称、简介、演职人员均为虚构示例，用于界面与交互演示；不存储、不托管、不播放任何真实影片文件。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-xs tracking-[0.24em] text-secondary-700 font-label uppercase">
                <span className="inline-block">{group.title}</span>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-accent-800/40 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div>
            <p className="text-xs tracking-[0.24em] text-secondary-700 font-label uppercase">友情链接</p>
            <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2">
              {friends.map((friend) => (
                <a
                  key={friend.href}
                  href={friend.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {friend.label}
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 text-xs text-foreground-600">
            <span className="inline-flex items-center h-7 px-2.5 rounded-md border border-accent-400/40 text-accent-300 font-label tracking-widest w-fit">
              18+
            </span>
            <span>© 2026 av免费网站 · 内容均为虚构演示</span>
          </div>
        </div>
      </div>
    </footer>
  );
}